var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:_vm.$ui.getRedMode() ? 'redmode' : ''},[(_vm.$user.loggedIn())?_c('SideMenu'):_vm._e(),_c('v-main',{staticClass:"pa-0",staticStyle:{"align-items":"center"}},[_c(_vm.$state.scene,{tag:"v-component",on:{"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave}})],1),_c('NotificationManager'),_c('ConfirmDlg',{ref:"confirm"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }